import { AllowanceTypeValues } from 'core/application/adminDashboard/benefitDetails/design/allowanceType'
import { ClassSelectioValues } from 'core/application/adminDashboard/benefitDetails/design/classSelection'
import { BenefitStartDateValues } from 'core/application/adminDashboard/benefitDetails/design/common/models'
import { BenefitDesignStateValues } from 'core/application/adminDashboard/benefitDetails/groupHra/benefitDesignState'
import { WizardStatus } from 'core/domain/wizard/wizard'

import { NavItemProps } from '../common/models'
import BenefitStartDate from './BenefitStartDate'
import ClassSelection from './ClassSelection'
import RestrictReimbursementCategories from './RestrictReimbursementCategories'
import AllowanceType from './SetAllowanceType'
import ClassDesign, { ClassDesignProps } from './classDesign'

export enum BenefitDesignStep {
  BenefitStartDate = 'gchra-benefit-start-date',
  ClassSelection = 'gchra-benefit-class-selection',
  AllowanceType = 'gchra-benefit-allowance-type',
  BenefitRestrictReimbursementCategories = 'gchra-benefit-restrict-reimburment-categories',
  DesignClasses = 'gchra-benefit-design-classes',
}

export const ReadonlyStepsWhenBenefitIsFinished: BenefitDesignStep[] = [
  BenefitDesignStep.ClassSelection,
  BenefitDesignStep.AllowanceType,
]

export const NavItemsMapping: NavItemProps[] = [
  {
    key: BenefitDesignStep.BenefitStartDate,
    component: BenefitStartDate,
    nextButtonTooltip: 'admin-dashboard.benefit-details.benefit-start-date.next-tooltip',
    mapState: (benefitDesignState: BenefitDesignStateValues | undefined): BenefitStartDateValues | undefined => {
      return benefitDesignState
        ? {
            benefitStartDate: benefitDesignState.benefitStartDate,
            planPeriodId: '',
          }
        : undefined
    },
  },
  {
    key: BenefitDesignStep.ClassSelection,
    component: ClassSelection,
    nextButtonTooltip: 'admin-dashboard.benefit-details.class-selection.next-tooltip',
    mapState: (benefitDesignState: BenefitDesignStateValues | undefined): ClassSelectioValues => {
      return {
        sameClassForAll: benefitDesignState ? benefitDesignState.sameClassForAll : null,
      }
    },
  },
  {
    key: BenefitDesignStep.AllowanceType,
    component: AllowanceType,
    nextButtonTooltip: 'admin-dashboard.benefit-details.allowance-type.next-tooltip',
    mapState: (benefitDesignState: BenefitDesignStateValues | undefined): AllowanceTypeValues => {
      return {
        allowanceType: benefitDesignState ? benefitDesignState.allowanceType : null,
        planPeriodId: '',
      }
    },
  },
  {
    key: BenefitDesignStep.BenefitRestrictReimbursementCategories,
    component: RestrictReimbursementCategories,
    nextButtonTooltip: 'admin-dashboard.benefit-details.allowance-type.next-tooltip',
    mapState: (benefitDesignState: BenefitDesignStateValues | undefined): any => {
      let restrictCategories = benefitDesignState && benefitDesignState.restrictedExpenseCategories.map((c) => c.id)
      return {
        planPeriodId: '',
        restrictedExpenseCategories: restrictCategories ?? [],
      }
    },
  },
  {
    key: BenefitDesignStep.DesignClasses,
    component: ClassDesign,
    nextButtonTooltip: 'admin-dashboard.benefit-details.class-design.single-class-finish-tooltip',
    mapState: (benefitDesignState: BenefitDesignStateValues | undefined): ClassDesignProps => {
      return {
        sameClassForAll:
          benefitDesignState && benefitDesignState.sameClassForAll !== null
            ? benefitDesignState.sameClassForAll
            : false,
        classes: benefitDesignState ? benefitDesignState.designClasses : [],
        status: benefitDesignState ? benefitDesignState.wizardStatus : WizardStatus.NotStarted,
        runOutDays: benefitDesignState?.runOutDays,
      }
    },
  },
]
